<template>
  <div
      :class="['flex items-center justify-between p-4 bg-white rounded-lg shadow-md', { 'mb-4': !status.includes('archived') }]">
    <div class="flex items-center space-x-4">
      <img :src="course_image_url" alt="Course Image" class="w-16 h-16 rounded-lg"/>
      <div class="text-right w-full">
        <span v-if="course_type_text"
              class="bg-[#999] text-white text-xs font-semibold px-3 py-1 rounded">{{ course_type_text }}</span>
        <div v-else class="h-5">

        </div>
        <h3 class="text-sm font-semibold pe-2">{{ course_name }}</h3>
        <p class="text-sm text-gray-600">
          <span v-if="details_type">
            {{ details_type }}
          </span>
          <span v-if="details_type">
            |
          </span>
          <span v-if="effort">
            الجهد المقدر: {{ effort }}
          </span>
          <span v-else>
            الجهد المقدر: 0
          </span>
        </p>
      </div>
    </div>
    <a :href="course_redirect_url">
      <button
          v-if="status.includes('in_progress') || status.includes('completed')"
          class="bg-[#277b9d] text-white px-2 md:min-w-[100px] xl:min-w-[150px]  md:min-h-[65px] xl:min-h-auto text-xs py-2 rounded-full hover:bg-white hover:text-[#277b9d] hover:border-[#277b9d] border-1 border-transparent cursor-pointer"
      >
          {{ status.includes('archived') ? 'استعراض الدورة المؤرشفة' : 'استعراض الدورة' }}
      </button>
    </a>
    <button
        v-if="status.includes('available') && !status.includes('archived')"
        class="bg-[#277b9d] text-white px-2 py-2 md:min-w-[100px] xl:min-w-[150px] md:min-h-[65px] xl:min-h-auto text-xs rounded-full hover:bg-white hover:text-[#277b9d] hover:border-[#277b9d] border-1 border-transparent cursor-pointer"
        @click="handleCourseRegister"
    >
      سجل الآن
    </button>
    <button
        v-if="status.includes('available') && status.includes('archived')"
        class="disabled bg-[#999] text-white md:min-w-[100px] xl:min-w-[150px] md:min-h-[65px] xl:min-h-auto text-xs px-2 py-2 rounded-full cursor-not-allowed"

    >
      سجل الآن
    </button>
  </div>

  <div v-if="status.includes('archived')" class="bg-yellow-100 p-1 flex w-full rounded-lg mt-1 mb-4">
    <span v-if="status.includes('available')" class="text-yellow-600">
        الدورة غير متاحة
      </span>
      <span v-else class="text-yellow-600">
        تم أرشفة الدورة يمكنك استعراض المحتوى فقط
      </span>
  </div>
</template>

<script>
import {registerUserCourse} from "~/services/public_program/apis.js";

export default {
  props: {
    course_name: String,
    course_type_text: String,
    effort: String,
    status: Array,
    course_image_url: String,
    course_redirect_url: String,
    details_type: String,
    course_id: String,
    reloadProgram: undefined
  },
  methods: {
    handleCourseRegister() {
      registerUserCourse(this.course_id).then(response => {
        setTimeout(() => {
          this.reloadProgram();
        }, 1000);
      });
    }
  }
};
</script>
